/* eslint-disable no-undef */
import React from "react";
import axios from "axios";
import { endpoints } from "../../../../services/apiurl";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { MantineReactTable } from "mantine-react-table";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, Button } from "@mui/material";
import PageTitle from "../../../UI/PageTitle";
import { InfinitySpin } from "react-loader-spinner";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "../../../../../node_modules/react-confirm-alert/src/react-confirm-alert.css";
import Pagination, {
  bootstrap5PaginationPreset,
} from "react-responsive-pagination";
import Input from "../../../UI/Input/Input";

const getItems = (ii) =>
  Array.from({ length: ii.length }, (v, k) => k).map((k) => ({
    id: `${ii[k].id}`,
    name: ii[k].name,
    price: ii[k].price,
    second_price: ii[k].second_price,

    status: ii[k].status,

    // price: ii[k].price,

    // last: ii[k].id,
    content: `item ${k}`,
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

class DishRestDetail extends React.Component {
  // Constructor
  constructor(props) {
    super(props);

    // console.log(this.props);
    this.state = {
      items: [],
      DataisLoaded: false,
      data: [],
      loading: false,
      status: "",
      order_by_price: "",
      page: 1,
      currentPage: 1,
      totalPages: 1,
      per_page: 20,
      rowCount: 0,
      cat_id: this.props.match.params.cat_id,
      pagination: {
        pageIndex: 0,
        pageSize: 10,
      },
      rest_id: localStorage.getItem("restro_id"),
      section_id: localStorage.getItem("section_id"),
    };
    this.bFilter1 = this.bFilter1.bind(this);

    //console.log(this.state.rest_id)
    //console.log(this.state.section_id)
  }

  componentDidMount() {
    const { location } = this.props;
    if (location.search != "") {
      const urlParams = new URLSearchParams(window.location.search);
      // console.log(urlParams, "urlParams");

      const filter2Param = urlParams.get("filter2");
      // console.log("incp", filter2Param);

      if (filter2Param) {
        this.name = filter2Param;
        this.bFilter1();
      }
    } else {
      this.fetchData();
    }
  }
  bFilter1 = async () => {
    //console.log(this.name);
    var name = this.name;
    var cat_id = this.state.cat_id;
    // var restro_id = this.state.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;

    axios
      .post(endpoints.dishFilter, {
        page,
        per_page,
        name,
        cat_id,
      })
      .then((response) => {
        // window.location.reload(true);
        this.setState({
          items: getItems(response.data.data),
          totalPages: response.data.total_pages,
          local: localStorage.setItem(
            "data",
            JSON.stringify(response.data.data)
          ),
          DataisLoaded: true,
        });
        // console.log(response.data);
      });
  };

  fetchData() {
    const { pagination } = this.state;
    // console.log(pagination);
    var cat_id = this.state.cat_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    const urlParams = new URLSearchParams(window.location.search);

    urlParams.set("start", `${pagination.pageIndex * pagination.pageSize}`);
    urlParams.set("size", `${pagination.pageSize}`);
    // console.log(urlParams);
    axios
      .post(endpoints.getDish, {
        page,
        per_page,
        cat_id,
      })
      .then((response) => {
        // console.log("response", response);
        this.setState({
          items: getItems(response.data.data),
          totalPages: response.data.total_pages,
          local: localStorage.setItem(
            "data",
            JSON.stringify(response.data.data)
          ),
          rowCount: response.data.total,
          DataisLoaded: true,
          currentPage: response.data.page,
        });
        // console.log(response.data.data);
      });
  }

  bFilter() {
    const { name, cat_id, page, per_page, status, order_by_price } = this.state;

    axios
      .post(endpoints.dishFilter, {
        page: this.state.page,
        per_page: this.state.per_page,
        name,
        status,
        order_by_price,
        cat_id: this.state.cat_id,
      })
      .then((response) => {
        this.setState({
          items: getItems(response.data.data),
          totalPages: response.data.total_pages,
          local: localStorage.setItem(
            "data",
            JSON.stringify(response.data.data)
          ),
          DataisLoaded: true,
        });
      });
  }

  onNameChange = (e) => {
    this.setState({ name: e.target.value }, () => {
      this.bFilter();
    });
  };

  onStatusChange = (e) => {
    this.setState({ status: e.target.value }, () => {
      this.bFilter();
    });
  };

  onPriceChange = (e) => {
    this.setState({ order_by_price: e.target.value }, () => {
      this.bFilter();
    });
  };

  handleResetFilters = () => {
    this.setState({ name: "", status: "", order_by_price: "" }, () => {
      this.setState(
        { currentPage: 1, pagination: { pageIndex: 0, pageSize: 10 } },
        () => {
          this.fetchData();
        }
      );
    });
  };

  move = (data) => {
    var cat_id = this.state.cat_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;

    this.setState({ DataisLoaded: false });

    axios
      .post(endpoints.dishcatupdateSorting, {
        data,
        page,
        per_page,
        cat_id,
      })
      .then((response) => {
        const updatedItems = getItems(response.data.data);

        // console.log(updatedItems);

        this.setState({
          items: updatedItems,
          DataisLoaded: true,
        });
      })
      .catch((error) => {
        console.error("Error updating dish order:", error);
        // Set loading state to true in case of an error
        this.setState({ DataisLoaded: true });
      });
  };

  removeContactHandler = async (id) => {
    try {
      await axios.post(endpoints.deleteDish, { id });
      // Filter out the deleted item
      const newContactList = this.state.items.filter(
        (contact) => contact.id !== id
      );
      // Update the state with the new list using this.setState
      this.setState({ items: newContactList });

      // Show a success toast
      toast.success("Dish deleted successfully!");
    } catch (error) {
      // Handle errors if necessary
      console.error("Error deleting contact:", error);
      // Show an error toast
      toast.error("Error deleting item");
    }
  };

  submit = async (id) => {
    confirmAlert({
      title: "DELETE",
      message: "Are you sure you want to Delete it?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            // Call the removeContactHandler function
            await this.removeContactHandler(id);
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  render() {
    const { status, name, order_by_price } = this.state;
    const columnss = [
      {
        accessorKey: "name",
        header: "Name",
      },

      {
        accessorKey: "price",
        header: "Price",
      },
      {
        accessorKey: "status",
        header: "Status",
      },
      {
        accessorKey: "actions",
        header: "Action",
      },
    ];

    const datas = this.state.items.map((item) => ({
      name: item.name,
      price:
        item.price == null || item.price == "" ? item.second_price : item.price,
      id: item.id,

      status: (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            className="custom-control-input"
            id={item.id + "check"}
            checked={item.status === "1"}
            onChange={() => sub(item.id, item.status)}
          />
          <label
            className="custom-control-label"
            style={{ cursor: "pointer" }}
            htmlFor={item.id + "check"}
          ></label>
          <ToastContainer />
        </div>
      ),
      actions: (
        <div className="d-flex align-items-start">
          <Link to={`/dashboard/editrestdish/${item.id}`}>
            <EditIcon />
          </Link>
          <span
            className="trash alternate outline icon"
            style={{
              color: "red",
              marginTop: "7px",
              marginLeft: "10px",
              cursor: "pointer",
            }}
            onClick={() => this.submit(item.id)}
          >
            <ToastContainer />
            <DeleteIcon />
          </span>
        </div>
      ),
    }));

    const { DataisLoaded } = this.state;

    const sub = (id, old_status) => {
      let newStatus = old_status === "1" ? "0" : "1";

      axios
        .post(endpoints.updateDishStatus, {
          id,
          status: newStatus,
        })
        .then((response) => {
          this.setState((prevState) => ({
            DataisLoaded: true,
            items: prevState.items.map((item) =>
              item.id === id ? { ...item, status: newStatus } : item
            ),
          }));

          // Display toaster notification for status change
          toast.success(
            `Dish Status ${newStatus === "1" ? "Active" : "Inactive"}`
          );
        })
        .catch((error) => {
          console.error("Error updating status:", error);

          // Display error toaster notification
          toast.error("Error updating dish status");
        });
    };

    const setCurrentPage = (id) => {
      this.state.currentPage = id;
      this.fetchData();
    };

    const onSelectChange = (per_page) => {
      this.state.per_page = per_page;
      this.fetchData();
    };

    return (
      <div className="App">
        <div className="col col-2">
          <label>Row Per Page </label>
          <select
            name="type"
            className="form-control"
            onChange={(e) => onSelectChange(e.target.value)}
            value={this.state.per_page}
          >

            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>

        <PageTitle
          title="Dish List"
          linkid={this.props.match.params.cat_id}
          linkurl="/dashboard/addrestdish"
          linkTitle={
            <div>
              <img
                src="https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/dish/icon/dishicon1.png"
                width={30}
                alt=""
                srcSet=""
              />
              &nbsp;&nbsp;Add Dish
            </div>
          }
        />

        <Card className="px-3 py-3">
          <form
            className="ui form"
            onSubmit={(e) => onSubmit(e)}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-md-3">
                <Input
                  id="name"
                  value={name}
                  type="text"
                  name="name"
                  place="Search Dish"
                  requiredInput="required"
                  onChange={this.onNameChange}
                />
              </div>

              <div className="col-md-2 mt-4">
                <select
                  name="status"
                  value={status}
                  onChange={this.onStatusChange}
                  required
                  className="form-control"
                  style={{ marginTop: "2px" }}
                >
                  <option value="">Status</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
              <div className="col-md-2 mt-4">
                <select
                  name="order_by_price"
                  value={order_by_price}
                  onChange={this.onPriceChange}
                  required
                  className="form-control"
                  style={{ marginTop: "2px" }}
                >
                  <option value="">Order By Price</option>
                  <option value="ASC">Asscending</option>
                  <option value="DESC">Decending</option>
                </select>
              </div>

              <div className="col-md-3 mt-4">
                <Button
                  style={{ marginTop: "2px" }}
                  variant="contained"
                  color="primary"
                  onClick={this.handleResetFilters}
                >
                  Reset Filters
                </Button>
              </div>
            </div>
          </form>
        </Card>

        <MantineReactTable
          autoResetPageIndex={false}
          columns={columnss}
          data={datas}
          enableColumnActions={false}
          enableColumnFilters={false}
          enableSorting={false}
          enableGlobalFilter={false}
          enableRowOrdering
          enableBottomToolbar={false}
          enablePagination={false}
          mantineRowDragHandleProps={({ table }) => ({
            onDragEnd: () => {
              const { draggingRow, hoveredRow } = table.getState();
              if (hoveredRow && draggingRow) {
                const newData = [...datas];
                const draggedItemId = draggingRow.original.id;

                newData.splice(
                  hoveredRow.index,
                  0,

                  {
                    ...newData.splice(draggingRow.index, 1)[0],
                    id: draggedItemId,
                  }
                );

                const idIndexMap = {};
                newData.forEach((item, index) => {
                  idIndexMap[item.id] = index;
                });

                this.setState({ items: newData });
                this.move(idIndexMap);
              }
            },
            style: { cursor: "grab" },
          })}
        />

        {!DataisLoaded && (
          <div className="spinner">
            <InfinitySpin
              visible={true}
              width="200"
              color="#fbaa1a"
              ariaLabel="infinity-spin-loading"
            />
          </div>
        )}

        <Pagination
          {...bootstrap5PaginationPreset}
          current={this.state.currentPage}
          total={this.state.totalPages}
          onPageChange={(e) => setCurrentPage(e)}
        />
      </div>
    );
  }
}

export default withRouter(DishRestDetail);
